export const planLevel = {
  free: 0,
  start: 1,
  premium: 2
};

